import * as ls from 'local-storage';

export const tokenValidator = async () => {
  const AccessToken: string = ls.get('AccessToken');
  const IdToken: string = ls.get('IdToken');
  if (AccessToken && IdToken) {
    return { valid: true, AccessToken: AccessToken, IdToken: IdToken };
  }
  return null;
};
